function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var LocalSearch = /*#__PURE__*/function () {
  function LocalSearch(autocomplete) {
    _classCallCheck(this, LocalSearch);

    this.autocomplete = autocomplete;
  }

  _createClass(LocalSearch, [{
    key: "search",
    value: function search(value) {
      this.autocomplete.options.forEach(filterOptions(value));
      var firstOption = this.autocomplete.visibleOptions[0];

      if (firstOption) {
        this.autocomplete.combobox.activate(firstOption);
      }

      this.autocomplete.checkIfListIsEmpty();
    }
  }, {
    key: "start",
    value: function start() {
      this.autocomplete.checkIfListIsEmpty();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.resetOptions();
    }
  }, {
    key: "resetOptions",
    value: function resetOptions() {
      var _iterator = _createForOfIteratorHelper(this.autocomplete.groups),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var group = _step.value;
          group.hidden = false;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this.autocomplete.options),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var option = _step2.value;
          option.hidden = false;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return LocalSearch;
}();

function filterOptions(query) {
  return function (option) {
    var group = option.closest('[role="group"]');

    if (query) {
      var value = option.getAttribute('data-text');
      var match = value === null || value === void 0 ? void 0 : value.toLowerCase().includes(query.toLowerCase());
      option.hidden = !match;

      if (group) {
        var options = Array.from(group.querySelectorAll('[role="option"]'));
        group.hidden = options.every(function (o) {
          return o.hidden;
        });
      }
    } else {
      option.hidden = false;

      if (group) {
        group.hidden = false;
      }
    }
  };
}

export { LocalSearch as default };